import { CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectorRef, Component, ComponentRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTree, MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { HtmlErrorComponent } from 'src/app/fragments/html-error/html-error.component';
import { DocumentService } from 'src/app/services/document/document.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { IdentifiantsTemporairesConnexion } from 'src/app/utils/interfaces/new/identifiantsTemporairesConnexion';
import { MSSClinicalDocumentInfo } from 'src/app/utils/interfaces/new/mss-clinical-document-info.interface';
import { MSSFolder } from 'src/app/utils/interfaces/new/mss-folder.interface';
import { MSSAddress, MSSAttachment, MSSEnumFlag, MSSEnumTypeMail, MSSMessage, MSSMessageToSend } from 'src/app/utils/interfaces/new/mss-message.interface';
import { MssCreateFolderComponent } from './mss-create-folder/mss-create-folder.component';
import { PresendClinicalDocumentModalComponent } from './presend-clinicaldocument-modal/presend-clinicaldocument-modal.component';
import { MssServiceFactory, MssTypeService } from 'src/app/services/mss/mss-service.factory';
import { RessourceSetting, RessourceTypeEnum } from 'src/app/utils/interfaces/new/RessourceSetting';
import { ConnectToMailizComponent } from './connect-to-mailiz/connect-to-mailiz.component';
import { ConnectToApicryptComponent } from './connect-to-apicrypt/connect-to-apicrypt.component';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { PatientService } from 'src/app/services/patient/patient.service';
import { InfosPatient } from 'src/app/utils/interfaces/new/infos-patient.interface';
import { ProgressFragment } from 'src/app/fragments/modal/progress/progress.fragment';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { CpxHandleServiceAbstract, SessionTypeEnum } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { InsRealservice } from 'src/app/services/ins/ins.service';
import { MessageReleveTmp } from 'src/app/services/mss/mss-service.abstract';
import { ActionEnum, DomainEnum, LogFonctionnelCallerService, LogFonctionnelService, LogObject, ResultEnum, TypeTargetEnum } from 'src/app/services/log-fonctionnel/log-fonctionnel.service';
import { RelevageApicryptComponent } from './relevage-apicrypt/relevage-apicrypt.component';
import { MssApicryptService } from 'src/app/services/mss/mss.apicrypt.service';

const FOLDER_ID_PREFIX = 'folder_';
const CLINICAL_DOCUMENT_PREFIX = 'clinicaldocument_';
export const IDENTIFIANT_NATIONAL_KEY = 'identifiant-national';

const practiceSettingKey = 'dmp_params_practice_setting';
const identifiantNationalKey = 'identifiant-national';
const professionSettingKey = 'dmp_params_profession_setting';
const specialiteSettingKey = 'dmp_params_specialite_setting';
const nomSettingKey = 'dmp_params_nom_setting';
const prenomSettingKey = 'dmp_params_prenom_setting';
const idnatStructureSettingKey = 'dmp_params_idnatstruct_setting';
const nomStructureSettingKey = 'dmp_params_nomstruct_setting';
const typeStructureSettingKey = 'dmp_params_typestruct_setting';

interface NgSelectAccount {
  id: string;
  libelle: string;
}

export interface SelectedAccount {
  accountName: string;
  provider: MssTypeService;
}

interface PaginationConfig {
  itemsPerPage: number;
  currentPage: number;
}

interface FlatTreeNode {
  expandable: boolean;
  folderId: number;
  name: string;
  level: number;
}

export interface MailizAccount {
  idnat: string;
  addresses: Array<string>;
}

@Component({
  selector: 'app-mss',
  templateUrl: './mss.component.html',
  styleUrls: ['./mss.component.scss']
})
export class MssComponent implements OnInit {

  public accounts: Array<NgSelectAccount> = [];

  public get accountSelected(): SelectedAccount {
    return this._accountSelected;
  }
  public set accountSelected(account: SelectedAccount) {
    this._mssSrv.switchService(account.provider);
    this._accountSelected = account;
    this._lastProviderSelected = account.provider;
  }
  private _accountSelected: SelectedAccount;

  public mustReleverCourrier = false;

  public treeControl: FlatTreeControl<FlatTreeNode>;
  private treeFlattener: MatTreeFlattener<MSSFolder, FlatTreeNode>;
  public dataSource: MatTreeFlatDataSource<MSSFolder, FlatTreeNode>;

  public get canCreateFolder(): boolean {
    return this._mssSrv.getService().canCreateFolders();
  }

  public get canRenameFolder(): boolean {
    return this._mssSrv.getService().canRenameFolders();
  }

  public get canRemoveFolder(): boolean {
    return this._mssSrv.getService().canRemoveFolders();
  }

  @ViewChild('treeSelector') tree: MatTree<MSSFolder>;

  public isMSSSet = false;
  public isConnected = false;
  public isOTPNeeded = false;
  public formGroup: FormGroup;
  public currentAccount: FormGroup;
  public formGroupOTP: FormGroup;
  public formGroupSwitchMail: FormGroup;
  public searchFormGroup: FormGroup;
  public folders: Array<MSSFolder> = [];
  public messagesDisplay: Array<MSSMessage> = [];
  public areMessagesLoading = false;
  public selectedFolderId: number;
  private _lastSelectedFolderId: number;
  public selectedMessageId: number;
  public selectedMessage: MSSMessage;
  public paginationConfig: PaginationConfig = {
    currentPage: 0,
    itemsPerPage: 10
  };
  public noMoreMessageForFolder = false;
  public isNextMessageLoading = false;
  public refreshing = false;
  public userMail: string;
  public selectedIdNat: string;
  public accountEmails: Array<string> = [];
  public listFoldersToDrop: Array<string> = [];
  public isExtendMessageZone = false;
  public identifiantsTemporaires: IdentifiantsTemporairesConnexion;
  public idNat: string;
  private authenticationErrorSubscription: Subscription;
  private _syncToken: string;
  public mssEnumFlag = MSSEnumFlag;
  private currentProfil;
  private _lastProviderSelected: MssTypeService;

  private _logCallSrv: LogFonctionnelCallerService;

  constructor(
    private _send: HeaderCommunicationService,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _mssSrv: MssServiceFactory,
    private _loginSrv: LoginService,
    private _patientSrv: PatientService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _documentSrv: DocumentService,
    private _resourceSrv: RessourceService,
    private _cdr: ChangeDetectorRef,
    private _strUtilsSrv: StringUtilsService,
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _insSrv: InsRealservice,
    private _logSrv: LogFonctionnelService
  ) {
    const head: Header = {
      isBack: true,
      title: 'Messagerie Sécurisé de Santé',
      backPage: 'messagerie'
    };
    this._send.announceHeader(head);

    const _transformer = (node: MSSFolder, level: number) => {
      return {
        expandable: !!node.folders && node.folders.length > 0,
        name: node.folderName,
        level,
        folderId: node.folderId
      };
    };

    this.treeControl = new FlatTreeControl<FlatTreeNode>(node => node.level, node => node.expandable);
    this.treeFlattener = new MatTreeFlattener(_transformer, node => node.level, node => node.expandable, node => node.folders);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  }

  async ngOnInit(): Promise<void> {
    await this._initData();
  }

  private async _saveMails(idNat: string, previousSelectedProvider: MssTypeService): Promise<void> {
    this._mssSrv.switchService(MssTypeService.mailiz);
    const accounts = await this._mssSrv.getService().listAccounts(idNat);
    if (accounts) {
      this.addAccountsToList(MssTypeService.mailiz, accounts, idNat);

      const settings = await this._resourceSrv.getResourceSettings(this.currentProfil.id, 'profil');
      const addressesStr = this._getSettings(settings, 'mailiz_account');
      let addresses: Array<MailizAccount> = [];
      if (addressesStr && addressesStr !== '') {
        addresses = JSON.parse(addressesStr);
        let found = false;
        for (const address of addresses) {
          if (address && address.idnat === idNat) {
            address.addresses = accounts;
            found = true;
          }
        }
        if (!found) {
          addresses.push({
            idnat: idNat,
            addresses: accounts
          });
        }
        await this._resourceSrv.postResourceSettings((this.currentProfil as Profil).id, 'profil', {
          ressourceId: (this.currentProfil as Profil).id,
          ressourceType: RessourceTypeEnum.Profil,
          settingKey: `mailiz_account`,
          settingType: 'object',
          settingValue: JSON.stringify(addresses)
        });
      } else {

        const value = [{
          idnat: idNat,
          addresses: accounts
        }];
        await this._resourceSrv.postResourceSettings((this.currentProfil as Profil).id, 'profil', {
          ressourceId: (this.currentProfil as Profil).id,
          ressourceType: RessourceTypeEnum.Profil,
          settingKey: `mailiz_account`,
          settingType: 'object',
          settingValue: JSON.stringify(value)
        });
      }
    }

    if (previousSelectedProvider) {
      this._mssSrv.switchService(previousSelectedProvider);
    }
  }

  private async _connexionOk(): Promise<void> {
    this.folders = [];
    this.messagesDisplay = [];
    this.selectedMessage = undefined;
    await this._initProvider();
    this.isConnected = true;
  }

  public async selectAccount(mustReleverCourrier: boolean): Promise<void> {
    const select = this.currentAccount.get('accountName').value;

    if (select) {
      const selectSplit = (select as string).split('$');
      const account = selectSplit[0];
      const provider = selectSplit[1];
      const idNat = selectSplit[2];

      this.mustReleverCourrier = mustReleverCourrier;
      this.accountSelected = { accountName: account, provider: provider as MssTypeService };
      const currentUserMail = this.userMail;
      const currentSelectedIdNat = this.selectedIdNat;
      const lastSelectedProvider = this._lastProviderSelected;
      this.userMail = account;
      this.selectedIdNat = idNat;
      this.areMessagesLoading = false;

      try {
        if ((provider as MssTypeService) === MssTypeService.mailiz) {
          await this._mssSrv.switchService(MssTypeService.mailiz);
          if (!await this._mssSrv.getService().isSessionValid({ email: account, idNat })) {
            const modal = this._modalSrv.openModal<ConnectToMailizComponent>(
              this._viewContainerRef,
              ConnectToMailizComponent
            ) as ComponentRef<ConnectToMailizComponent>;

            modal.instance.idNat = idNat;
            const sub = modal.instance.closeEmitter.subscribe(async (res: string) => {
              modal.destroy();
              sub.unsubscribe();

              if (res === 'connected') {
                await this._saveMails(idNat, lastSelectedProvider);
                await this._connexionOk();
              } else {
                this.userMail = currentUserMail;
                this.selectedIdNat = currentSelectedIdNat;
              }
            });
          } else {
            await this._saveMails(idNat, lastSelectedProvider);
            await this._connexionOk();
          }
        } else if ((provider as MssTypeService) === MssTypeService.apicrypt) {
          await this._mssSrv.switchService(MssTypeService.apicrypt);
          if (!await this._mssSrv.getService().isSessionValid({ email: account, idNat })) {
            const modal = this._modalSrv.openModal<ConnectToApicryptComponent>(
              this._viewContainerRef,
              ConnectToApicryptComponent
            ) as ComponentRef<ConnectToApicryptComponent>;
            modal.instance.inputAccount = account;
            const sub = modal.instance.closeEmitter.subscribe(async (res: string) => {
              modal.destroy();
              sub.unsubscribe();

              if (res === 'connected') {
                await this._connexionOk();
              } else {
                this.userMail = currentUserMail;
                this.selectedIdNat = currentSelectedIdNat;
              }
            });
          } else {
            await this._connexionOk();
          }

        }
      } catch (e) {
        this._openAlertModal(e.message);
        this.userMail = currentUserMail;
        this.selectedIdNat = currentSelectedIdNat;
      }
    }
  }

  public async connectWithMailiz(): Promise<void> {
    const modal = this._modalSrv.openModal<ConnectToMailizComponent>(
      this._viewContainerRef,
      ConnectToMailizComponent
    ) as ComponentRef<ConnectToMailizComponent>;

    modal.instance.idNat = this.idNat;

    const sub = modal.instance.closeEmitter.subscribe(async (res?: string) => {
      modal.destroy();
      sub.unsubscribe();

      if (res === 'connected') {
        // ID Changé avec le formulaire dans la modale.
        await this._saveMails(modal.instance.idNat, this._lastProviderSelected);
      }
    });
  }

  public hasChild = (_: number, node: MSSFolder) => {
    return !!node.folders && node.folders.length > 0;
  }

  public async searchMessages(folderId: number, node: FlatTreeNode): Promise<void> {
    const caller = this.userMail;
    if (node.expandable && !this.treeControl.isExpanded(node)) {
      return;
    }

    this.areMessagesLoading = true;
    this.selectedFolderId = folderId;
    this.selectedMessage = undefined;
    this.selectedMessageId = undefined;

    try {
      this.paginationConfig = {
        currentPage: 0,
        itemsPerPage: this.paginationConfig.itemsPerPage
      };
      const tmpMsg = await this._searchMessages(folderId);
      if (caller === this.userMail) {
        this.messagesDisplay = tmpMsg;
        this.noMoreMessageForFolder = false;
      }

      if (this._mssSrv.getService().canSyncMessages()) {
        await this.refresh();
      }
    } catch (e) {
      this._openAlertModal(e.message);
    } finally {
      this.areMessagesLoading = false;
    }
  }

  public async createFolder(folderId: number): Promise<void> {
    const modal = this._modalSrv.openModal<MssCreateFolderComponent>(
      this._viewContainerRef,
      MssCreateFolderComponent
    ) as ComponentRef<MssCreateFolderComponent>;
    const sub = modal.instance.closeEmitter.subscribe(async (folderName?: string) => {
      if (folderName) {
        const loading = this._modalSrv.openLoading(this._viewContainerRef);

        try {
          const newFolder = await this._mssSrv.getService().createFolder(
            { email: this.userMail, idNat: this.selectedIdNat },
            folderName,
            folderId
          );

          const parentFolder = this._findFolderById(folderId);

          if (parentFolder) {
            if (!parentFolder.folders) {
              parentFolder.folders = [];
            }

            parentFolder.folders.push({
              folders: [],
              folderId: newFolder.folderId,
              folderName: newFolder.folderName,
              folderNbUnread: 0
            });
            this.dataSource.data = [];
            this.dataSource.data = this.folders;
          }

        } catch (e) {
          this._openAlertModal(e.message);
        } finally {
          loading.destroy();
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public async deleteFolder(folderId: number): Promise<void> {
    const modal = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Confirmation',
      'Êtes-vous certains de vouloir supprimer ce dossier ?'
    );

    const sub = modal.instance.closeEmitter.subscribe(async (val: boolean) => {
      if (val) {
        const loading = this._modalSrv.openLoading(this._viewContainerRef);

        try {
          await this._mssSrv.getService().trashFolder({ email: this.userMail, idNat: this.selectedIdNat }, folderId);

          const parentFolder = this._findParentFolderByChildrenId(folderId);

          if (parentFolder) {
            parentFolder.folders.splice(parentFolder.folders.findIndex(f => f.folderId === folderId), 1);
          } else {
            this.folders.splice(this.folders.findIndex(f => f.folderId === folderId), 1);
          }
          this.dataSource.data = [];
          this.dataSource.data = this.folders;
        } catch (e) {
          this._openAlertModal(e.message);
        } finally {
          loading.destroy();
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public async renameFolder(folderId: number): Promise<void> {
    const modal = this._modalSrv.openModal<MssCreateFolderComponent>(
      this._viewContainerRef,
      MssCreateFolderComponent
    ) as ComponentRef<MssCreateFolderComponent>;
    modal.instance.validButtonLabel = 'Renommer';
    const sub = modal.instance.closeEmitter.subscribe(async (folderName?: string) => {
      if (folderName) {
        const loading = this._modalSrv.openLoading(this._viewContainerRef);

        try {
          await this._mssSrv.getService().renameFolder(
            { email: this.userMail, idNat: this.selectedIdNat },
            folderId,
            folderName
          );

          const folder = this._findFolderById(folderId);
          if (folder) {
            folder.folderName = folderName;
            this.dataSource.data = [];
            this.dataSource.data = this.folders;
          }

        } catch (e) {
          this._openAlertModal(e.message);
        } finally {
          loading.destroy();
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public async dropMessage(event: CdkDragDrop<CdkDropList>): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      const folderId = Number(event.container.id.split(FOLDER_ID_PREFIX)[1]);
      // On update le message
      await this._mssSrv.getService().moveMessages(
        { email: this.userMail, idNat: this.selectedIdNat },
        [event.previousContainer.data[event.previousIndex].messageId],
        folderId
      );

      // On met à jours les listes affichées à l'écran
      this.messagesDisplay.splice(event.previousIndex, 1);
    } catch (e) {
      this._openAlertModal(e.message);
    } finally {
      loading.destroy();
    }
  }

  public async refresh(): Promise<void> {
    this.refreshing = true;

    try {
      if (this.selectedFolderId || this._lastSelectedFolderId) {
        this.paginationConfig = {
          currentPage: 0,
          itemsPerPage: this.paginationConfig.itemsPerPage
        };

        const syncMessages = await this._mssSrv.getService().syncMessages(
          { email: this.userMail, idNat: this.selectedIdNat },
          this.selectedFolderId || this._lastSelectedFolderId,
          this._syncToken && this._syncToken !== '' ? this._syncToken : undefined
        );
        this._syncToken = syncMessages.token;
        const modifiedMessages: Array<MSSMessage> = [];
        for (const msg of this.messagesDisplay) {
          const found = syncMessages.modifiedMessages.findIndex(m => m.messageId === msg.messageId);
          if (found > -1) {
            modifiedMessages.push(syncMessages.modifiedMessages[found]);
            syncMessages.modifiedMessages.splice(found, 1);
          } else {
            const delFound = syncMessages.deletedMessageIds.includes(msg.messageId);
            if (!syncMessages.deletedMessageIds.find(delMsg => delMsg === msg.messageId)) {
              modifiedMessages.push(msg);
            }
          }
        }

        for (const syncMsg of syncMessages.modifiedMessages) {
          modifiedMessages.unshift(syncMsg);
        }

        this.messagesDisplay = modifiedMessages;
      } else if (!this._mssSrv.getService().canSyncMessages()) {
        this.messagesDisplay = await this._searchMessages(undefined);
      }
    } catch (e) {
      this._openAlertModal(e.message);
    } finally {
      this.refreshing = false;
    }
  }

  public createMessage(): void {
    this._lastSelectedFolderId = this.selectedFolderId;
    this.selectedFolderId = undefined;
    this.selectedMessageId = undefined;

    this.selectedMessage = {
      date: new Date(),
      folderId: undefined,
      messageId: undefined,
      size: undefined,
      subject: undefined,
      addresses: [],
      flags: [MSSEnumFlag.DRAFT]
    };
  }

  private _addFoldersToDropList(): void {
    const addFolderIdToDropList = (folderId: number) => {
      if (!this.listFoldersToDrop.find(f => f === `${FOLDER_ID_PREFIX}${folderId}`)) {
        this.listFoldersToDrop.push(`${FOLDER_ID_PREFIX}${folderId}`);
      }
    };

    const browsFolders = (folder: MSSFolder) => {
      addFolderIdToDropList(folder.folderId);

      if (folder.folders && folder.folders.length > 0) {
        for (const f of folder.folders) {
          browsFolders(f);
        }
      }
    };

    for (const folder of this.folders) {
      browsFolders(folder);
    }
  }

  public async showMessage(messageId: number): Promise<void> {
    const message = this.messagesDisplay.find(m => m.messageId === messageId);

    if (message) {
      // Clean Clinical Documents
      if (message.attachments) {
        for (const att of message.attachments) {
          if (att.clinicalDocument === undefined) {
            const clinicalDocument = att.fileName.startsWith(CLINICAL_DOCUMENT_PREFIX);
            att.clinicalDocument = clinicalDocument;
            att.fileName = att.fileName.substring(clinicalDocument ? CLINICAL_DOCUMENT_PREFIX.length : 0);
          }
        }
      }
      this.selectedMessageId = messageId;
      this.selectedMessage = message;
    }


    // Si message non-lu, le passer à lu
    if (message.flags && message.flags.includes(MSSEnumFlag.UNREAD)) {
      if (message.addresses.find(a => a.type === undefined)) {
        const modal = this._modalSrv.openModalConfirmation(
          this._viewContainerRef,
          'Confirmation',
          `L'expéditeur du mail a demandé à recevoir une notification dès que vous aurez lu ce mail.

          Voulez-vous envoyer cette notification à l'expéditeur ?`
        );

        const sub = modal.instance.closeEmitter.subscribe(async (res) => {
          if (res) {
            await this.sendAccuseReception(message);
          }
          sub.unsubscribe();
        });
      }

      await this._mssSrv.getService().markMessageAsRead(
        { email: this.userMail, idNat: this.selectedIdNat },
        messageId, message.technicalId
      );

      message.flags.splice(message.flags.indexOf(MSSEnumFlag.UNREAD), 1);
    }
  }

  public async sendAccuseReception(message: MSSMessage): Promise<void> {
    const ackAdress = message.addresses.find(a => a.type === undefined);
    const ackToAdress = message.addresses.find(a => a.type === MSSEnumTypeMail.TO);

    const currentProfilStr = localStorage.getItem('currentProfil');
    let currentProfil: Profil;
    if (currentProfilStr && currentProfilStr !== '') {
      currentProfil = JSON.parse(currentProfilStr) as Profil;
    }

    const toAdress = JSON.parse(JSON.stringify(ackAdress));
    toAdress.type = MSSEnumTypeMail.TO;
    const fromAddress: MSSAddress = {
      email: this.userMail,
      type: MSSEnumTypeMail.FROM,
      name: currentProfil && currentProfil.utilisateur && currentProfil.utilisateur.prenom && currentProfil.utilisateur.nom
        ? `${currentProfil.utilisateur.prenom} ${currentProfil.utilisateur.nom}` : undefined
    };
    const accuseReception: MSSMessageToSend = {
      messageData: {
        addresses: [
          fromAddress,
          toAdress
        ],
        body: `Le mail envoyé le ${message.date} au destinataire ${ackToAdress.email} avec l'objet "${message.subject}" a été affiché. Cela ne signifie aucunement que ce mail ait été lu (ou compris).`,
        subject: `Accusé de réception - ${message.subject}`,
        isHtml: true,
      }
    };
    this.sendMessage(accuseReception);
  }

  public async getNextMessages(): Promise<void> {
    this.isNextMessageLoading = true;

    try {
      this.paginationConfig = {
        currentPage: this.paginationConfig.currentPage + 1,
        itemsPerPage: this.paginationConfig.itemsPerPage
      };
      const nextMessages = await this._searchMessages(this.selectedFolderId);

      if (this._mssSrv.getService().isSearchMessageHandlePagination()) {
        if (nextMessages.length > 0) {
          for (const nm of nextMessages) {
            this.messagesDisplay.push(nm);
          }
        } else {
          this.noMoreMessageForFolder = true;
        }
      } else {
        this.messagesDisplay = nextMessages;
      }

    } catch (e) {
      this._openAlertModal(e.message);
    } finally {
      this.isNextMessageLoading = false;
    }
  }

  public getMessageSender(message: MSSMessage): string {
    if (message.addresses) {
      for (const address of message.addresses) {
        if (address.type === MSSEnumTypeMail.FROM) {
          return address.name ? address.name : address.email;
        }
      }
    }
  }

  public getMessageDate(message: MSSMessage): Date {
    return moment(message.date, 'DD/MM/YYYY HH:mm:ss').toDate();
  }

  public async downloadAttachment(attachment: MSSAttachment): Promise<void> {
    if (this.selectedMessage) {
      const loading = this._modalSrv.openLoading(this._viewContainerRef);

      try {
        let url = '';
        if (attachment.file && attachment.contentType) {
          url = `data:${attachment.contentType};base64,${attachment.file}`;
        } else {
          const {file} = await this._mssSrv.getService().downloadAttachment(
            { email: this.userMail, idNat: this.selectedIdNat },
            this.selectedMessage.messageId,
            attachment
          );
          url = window.URL.createObjectURL(file);
        }

        const a = window.document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = attachment.fileName;
        window.document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        window.document.body.removeChild(a);
      } catch (e) {
        this._openAlertModal(e.message);
      } finally {
        loading.destroy();
      }
    }
  }


  public async addAttachmentToPatient(attachment: MSSAttachment): Promise<void> {
    const modal = this._modalSrv.openModalSearchPatient(this._viewContainerRef);
    const sub = modal.instance.closeEmitter.subscribe(async (idPatient: string) => {
      if (idPatient) {
        const patient = await this._patientSrv.findOnePatientInfos(idPatient);
        this.pushAttachmentToPatient(patient, attachment);
      }
      this._modalSrv.close(modal);
      sub.unsubscribe();
    });
  }

  public pushAttachmentToPatient(patient: InfosPatient, attachment: MSSAttachment): void{
    const modal = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Ajouter au dossier patient',
      `Voulez-vous ajouter la pièce jointe "${attachment.fileName}" au dossier du patient "${this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)} ${patient.nom.toLocaleUpperCase()} (${patient.numeroDossier})" ?`
    );

    const sub = modal.instance.closeEmitter.subscribe(async (res) => {
      if (res) {

        const {file, base64} = await this._mssSrv.getService().downloadAttachment(
          { email: this.userMail, idNat: this.selectedIdNat },
          this.selectedMessage.messageId,
          attachment
        );
        console.log(base64);

        const loading = this._modalSrv.openLoading(this._viewContainerRef);
        let isError = false;
        try {
          const profilStr = localStorage.getItem('currentProfil');
          const profil = JSON.parse(profilStr);

          // On upload le document
          const documentGEDId = await this._documentSrv.uploadFile({
            content: base64,
            fileName: attachment.fileName,
            mime: attachment.contentType
          });

          await this._documentSrv.createDocument(
            patient.id, {
            authorId: profil.id,
            contentType: attachment.contentType,
            fileName: attachment.fileName,
            gedId: documentGEDId,
            titre: attachment.fileName,
            typeId: 'b98d0840-13c5-44ef-a927-99610bb9174a', // TODO En dur ?!
            weight: file.size
          }
          );

          this._logSrv.getConfiguration(DomainEnum.Messagerie).addLog({
            action: ActionEnum.Create,
            result: ResultEnum.Success,
            typeTarget: TypeTargetEnum.NONE,
            subDomain: this._lastProviderSelected === MssTypeService.apicrypt ? 'Intégration message APICRYPT' : 'Intégration message MSS',
            details: `Intégration de la PJ (${attachment.fileName}) dans le dossier patient (ID: ${patient.id})`
          });
        } catch (e) {
          isError = true;
          this._openAlertModal(e.message);
        } finally {
          if (!isError) {
            this._modalSrv.openAlert(
              this._viewContainerRef,
              'Confirmation',
              `La pièce jointe "${attachment.fileName}" à bien été ajoutée au dossier du patient "${this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)} ${patient.nom.toLocaleUpperCase()} (${patient.numeroDossier})".`
            );
          }

          loading.destroy();
        }
      }
      sub.unsubscribe();
      modal.destroy();
    });
  }

  // public async addAttachmentToPatient(): Promise<void> {
  //   localStorage.setItem('MSSLinkAttachmentSearchPatient', JSON.stringify());
  //   await this._router.navigateByUrl(this._router.createUrlTree(['/user/patient'], {
  //     queryParams: {
  //       navigateToMSS: true
  //     }
  //   }));
  // }

  public async deleteMessage(message: MSSMessage): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      await this._mssSrv.getService().deleteMessage(
        { email: this.userMail, idNat: this.selectedIdNat },
        message.messageId
      );

      await this.refresh();
    } catch (e) {
      this._openAlertModal(e.message);
    } finally {
      loading.destroy();
    }
  }

  public async unselectMessage(): Promise<void> {
    this.selectedMessageId = undefined;
    this.selectedMessage = undefined;
  }

  public async saveDraft(message: MSSMessageToSend): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      if (message.messageData.attachments) {
        for (const attachment of message.messageData.attachments) {
          if (attachment.clinicalDocument) {
            attachment.fileName = CLINICAL_DOCUMENT_PREFIX + attachment.fileName;
          }
          delete attachment.clinicalDocument;
        }
      }
      // On sauvegarde le brouillon
      const draftMsg = await this._mssSrv.getService().draftMessage(
        { email: this.userMail, idNat: this.selectedIdNat },
        JSON.parse(JSON.stringify(message))
      );
      // Si le message a un ID
      // alors on le récupère dans la liste des messages pour mettre à jour ses informations
      if (message.messageData.messageId) {
        const msg = this.messagesDisplay.find(m => m.messageId === message.messageData.messageId);
        msg.attachments = [];
        if (draftMsg.attachments && draftMsg.attachments.length > 0) {
          for (const att of draftMsg.attachments) {
            let clinicalDocument = false;
            if (att.fileName.startsWith(CLINICAL_DOCUMENT_PREFIX)) {
              clinicalDocument = true;
            }
            msg.attachments.push({
              contentType: att.contentType,
              clinicalDocument,
              fileName: att.fileName.substring(clinicalDocument ? CLINICAL_DOCUMENT_PREFIX.length : 0),
              part: att.part
            });
          }
        }
        msg.body = message.messageData.body;
        msg.date = new Date();
        msg.subject = message.messageData.subject;

        for (const addr of message.messageData.addresses) {
          if (addr.type !== MSSEnumTypeMail.FROM) {
            msg.addresses.push(addr);
          }
        }
      } else {
        // On retablie le clinical document
        if (message.messageData.attachments && message.messageData.attachments.length > 0) {
          for (const att of message.messageData.attachments) {
            if (att.fileName.startsWith(CLINICAL_DOCUMENT_PREFIX)) {
              att.clinicalDocument = true;
            }
            att.fileName = att.fileName.substring(att.clinicalDocument ? CLINICAL_DOCUMENT_PREFIX.length : 0);
          }
        }

        // TODO Mettre à jour la liste des messages du dossier en appelant la méthode de synchronisation
        if (this._lastSelectedFolderId) {
          this.refresh();
        }

        const draftFolder = this.folders.find(f => {
          if (f.folderName === 'Drafts') {
            return f;
          }
        });
        this.selectedMessageId = draftMsg.messageId;

        this.selectedMessage = {
          date: draftMsg.date,
          folderId: draftFolder.folderId,
          messageId: draftMsg.messageId,
          size: draftMsg.size,
          subject: message.messageData.subject,
          addresses: message.messageData.addresses,
          attachments: message.messageData.attachments,
          body: message.messageData.body,
          flags: [MSSEnumFlag.SENT_BY_ME, MSSEnumFlag.DRAFT]
        };
        if (!this._lastSelectedFolderId) {
          this.messagesDisplay.push(this.selectedMessage);
        }
      }

    } catch (e) {
      if (e.message === 'ERR_FR_MAX_BODY_LENGTH_EXCEEDED') {
        this._openAlertModal('Les pièces jointes ajoutées dépassent la taille maximum autorisée');

        if (message.messageData.messageId) {
          const msg = this.messagesDisplay.find(m => m.messageId === message.messageData.messageId);
          msg.attachments = msg.attachments.filter(att => att.part);
        }
      } else {
        this._openAlertModal(e.message);
      }
    } finally {
      loading.destroy();
    }
  }

  public async sendMessage(message: MSSMessageToSend): Promise<void> {
    const _logEnvoi = async (rst: ResultEnum) => {
      if (message.patientInfo) {
        const fichePatient = await this._patientSrv.findOnePatientFiche(message.patientInfo.patientId);
        if (fichePatient && fichePatient.identiteStatutId === '95a6081f-5260-44b8-9661-e4795e1cfcaf') { // TODO Modifier cette condition par une vérification sur patient.isQualifie quand ça sera mis en place
          const dests = message.messageData.addresses
            .filter(addr => addr.type !== MSSEnumTypeMail.FROM)
            .map(addr => `- ${addr.email}`)
            .join('\n');
          const details = `INS patient : ${message.patientInfo.couverture.ins && message.patientInfo.couverture.insKey && message.patientInfo.couverture.oid ? message.patientInfo.couverture.ins + ' ' + message.patientInfo.couverture.insKey + ' (' + message.patientInfo.couverture.oid + ')'  : 'inconnu'}\nDestinataires : \n${dests}`;
          this._addLog({
            action: ActionEnum.Create,
            result: rst,
            typeTarget: TypeTargetEnum.Patient,
            idTarget: message.patientInfo.patientId,
            details: rst === ResultEnum.Success ? details : undefined
          });
        }
      }
    };
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      let askForClinicalInfo;
      if (message.messageData.attachments.length === 1 && message.messageData.attachments[0].clinicalDocument) {
        askForClinicalInfo = await new Promise<MSSClinicalDocumentInfo | undefined>(async (resolve, reject) => {
          try {
            const modal = this._modalSrv.openModal<PresendClinicalDocumentModalComponent>(
              this._viewContainerRef,
              PresendClinicalDocumentModalComponent
            ) as ComponentRef<PresendClinicalDocumentModalComponent>;
            modal.instance.setDocTitle(message.messageData.attachments[0].fileName);
            const sub = modal.instance.closeEmitter.subscribe((infos?: MSSClinicalDocumentInfo) => {
              resolve(infos);
              modal.destroy();
              sub.unsubscribe();
            });
          } catch (e) {
            reject(e);
          }
        });
        await this._mssSrv.getService().sendMessage(
          { email: this.userMail, idNat: this.selectedIdNat },
          message,
          askForClinicalInfo
        );
      } else {
        // On envoi le message
        await this._mssSrv.getService().sendMessage(
          { email: this.userMail, idNat: this.selectedIdNat },
          message
        );
      }
      // Enleve le message juste envoyé de la gauche
      this.selectedMessage = undefined;
      this.selectedMessageId = undefined;

      // On log l'envoi de message
      _logEnvoi(ResultEnum.Success);

      this.refresh();
      loading.destroy();
      this._openAlertModal('Votre message a correctement été envoyé.', 'Message envoyé');
    } catch (e) {
      this._openAlertModal(e.message);
      loading.destroy();

      // On log l'envoi de message
      _logEnvoi(ResultEnum.Error);
    }
  }

  public doExtendMessage(doExtend: boolean): void {
    this.isExtendMessageZone = doExtend;
  }

  public async doSearchMessage(): Promise<void> {
    const modal = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      this.selectedFolderId = undefined;
      this.selectedMessageId = undefined;
      this.selectedMessage = undefined;

      const result = await this._mssSrv.getService().fullTextSearchMessages(
        { email: this.userMail, idNat: this.selectedIdNat }, {
        query: {
          searchString: this.searchFormGroup.get('plainText').value
        }
      }
      );

      this.messagesDisplay = result;
    } catch (e) {
      this._openAlertModal(e.message);
    } finally {
      modal.destroy();
    }
  }

  public getNodeMargin(node: FlatTreeNode): string {
    return `${ node.level * 1.5 }rem`;
  }

  public async switchEmail(email: string): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      if (email && email !== '') {
        await this.handleFolders(email);
      }
    } catch (e) {
      const alert = this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        'Une erreur s\'est produite en chargeant les données de cette adresse mail'
      );
    } finally {
      loading.destroy();
    }
  }

  private addAccountsToList(provider: MssTypeService, accounts: Array<string>, idNat?: string): void {
    this._mssSrv.switchService(provider);
    for (const account of accounts) {
      if (!this.accounts.find(a => a.id === `${account}$${provider}$${idNat}` || a.id === `${account}$${provider}`)) {
        this.accounts.push({
          id: idNat ? `${account}$${provider}$${idNat}` : `${account}$${provider}`,
          libelle: idNat ? `${this._mssSrv.getService().providerLibellePrefix()} : ${account} (${idNat})` : `${this._mssSrv.getService().providerLibellePrefix()} : ${account}`,
        });
      }
    }

    // On switch vers le dernier provider sélectionné
    this.switchToLastSelectedProvider();
  }

  private switchToLastSelectedProvider(): void {
    this._mssSrv.switchService(this._lastProviderSelected);
  }

  private async _initData(): Promise<void> {
    const modal = this._modalSrv.openLoading(this._viewContainerRef);

    const currentProfilStr = localStorage.getItem('currentProfil');
    let params: Array<RessourceSetting>;
    if (currentProfilStr && currentProfilStr !== '') {
      this.currentProfil = JSON.parse(currentProfilStr);
      params = await this._resourceSrv.getResourceSettings(this.currentProfil.id, 'profil');
      const identifiantNationalSetting = this._resourceSrv.getSettingFromArray(params, IDENTIFIANT_NATIONAL_KEY);
      this.idNat = identifiantNationalSetting ? identifiantNationalSetting.value : '';
    }

    this.currentAccount = this._formBuilder.group({
      accountName: ['', Validators.required]
    });

    if (this.currentProfil) {
      try {
        const settings = await this._resourceSrv.getResourceSettings((this.currentProfil as Profil).id, 'profil');
        const addressesStr = this._getSettings(settings, 'mailiz_account');
        if (addressesStr && addressesStr !== '') {
          const addresses: Array<MailizAccount> = JSON.parse(addressesStr);
          for (const address of addresses) {
            this.addAccountsToList(MssTypeService.mailiz, address.addresses, address.idnat);
          }
        }
      } catch (e) {
        console.log('error : ', e);
      }

      try {
        this._mssSrv.switchService(MssTypeService.apicrypt);
        const accounts = await this._mssSrv.getService().listAccounts(this.selectedIdNat);
        this.addAccountsToList(MssTypeService.apicrypt, accounts);
      } catch (e) {
        console.log('error : ', e);
      }
      this.accounts = [...this.accounts];
    }

    try {
      if (this.currentProfil) {
        // On récupère les paramètres de pagination
        const limit = this._resourceSrv.getSettingFromArray(params, 'mss_paginate_limit');
        this.paginationConfig.itemsPerPage = limit && limit.value !== '' && Number(limit.value)
          ? Number(limit.value)
          : this.paginationConfig.itemsPerPage;
      }

      // On vérifie l'existence qu'une messagerie MSS soit paramétrée
      this.isMSSSet = await this._isMSSSet();
      if (!this.isMSSSet) {
        return;
      }

      this.searchFormGroup = this._formBuilder.group({
        plainText: ['', [Validators.required]]
      });

      this.formGroupSwitchMail = this._formBuilder.group({
        email: [this.userMail && this.userMail !== '' ? this.userMail : '']
      });

    } catch (e) {
      this._openAlertModal(e.message);
    } finally {
      modal.destroy();
    }
  }

  private async _getFolders(mail: string, folderId?: number): Promise<Array<MSSFolder>> {
    return new Promise<Array<MSSFolder>>(async (resolve, reject) => {
      try {
        const folders = await this._mssSrv.getService().listFolders({ email: mail, idNat: this.selectedIdNat }, folderId);
        resolve(folders);
      } catch (e) {
        reject(e);
      }
    });
  }

  private async handleFolders(email?: string): Promise<void> {
    // On récupère les dossier de messagerie
    if (this._mssSrv.getService().canListFolders()) {
      if (this.userMail) {
        this.folders = await this._getFolders(this.userMail);
      }
    } else {
      this.folders = [{
        folderId: 0,
        folderName: 'Boîte de réception',
        folderNbUnread: 1,
        folders: []
      }];
    }

    this._addFoldersToDropList();

    this.dataSource.data = this.folders;

    console.log(this.treeControl);
  }

private _getSettings = (params: RessourceSetting[], settingKey: string): string|undefined => {
  const temp = params.find(p => p.settingKey === settingKey);
  return temp ? temp.settingValue : undefined;
}

  private async _isMSSSet(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        let resourceId = '';
        const currentProfilStr = localStorage.getItem('currentProfil');
        if (currentProfilStr && currentProfilStr !== '') {
          const currentProfil = JSON.parse(currentProfilStr);
          resourceId = currentProfil.id;
        }
        if (resourceId) {
          const params = await this._resourceSrv.getResourceSettings(resourceId, 'profil');
          if (params) {
            const practiceSetting = this._getSettings(params, practiceSettingKey);
            const identifiantNationalSetting = this._getSettings(params, identifiantNationalKey);
            const professionSetting = this._getSettings(params, professionSettingKey);
            // const specialiteSetting = this._getSettings(params, specialiteSettingKey);
            const nomSetting = this._getSettings(params, nomSettingKey);
            const prenomSetting = this._getSettings(params, prenomSettingKey);
            const idnatStructureSetting = this._getSettings(params, idnatStructureSettingKey);
            const nomStructureSetting = this._getSettings(params, nomStructureSettingKey);
            const typeStructureSetting = this._getSettings(params, typeStructureSettingKey);

            resolve(!!practiceSetting && !!identifiantNationalSetting &&
              !!professionSetting && !!nomSetting &&
              !!prenomSetting && !!idnatStructureSetting && !!nomStructureSetting &&
              !!typeStructureSetting);
          }
        } else {
          resolve(false);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  private _findFolderById(folderId: number): MSSFolder | undefined {
    const findFolder = (folder: MSSFolder): MSSFolder | undefined => {
      if (folder.folders) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < folder.folders.length; i++) {
          if (folder.folders[i].folderId === folderId) {
            return folder.folders[i];
          } else if (folder.folders[i].folders && folder.folders[i].folders.length > 0) {
            return findFolder(folder.folders[i]);
          }
        }
      }
    };

    for (const folder of this.folders) {
      if (folder.folderId === folderId) {
        return folder;
      } else {
        const f = findFolder(folder);
        if (f) {
          return f;
        }
      }
    }
  }

  private _findParentFolderByChildrenId(folderId: number): MSSFolder | undefined {
    const findFolder = (folder: MSSFolder): MSSFolder | undefined => {
      if (!folder.folders) {
        return;
      }

      const fold = folder.folders.find(f => f.folderId === folderId);
      if (fold) {
        return folder;
      } else {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < folder.folders.length; i++) {
          if (folder.folders[i].folders && folder.folders[i].folders.length > 0) {
            return findFolder(folder.folders[i]);
          }
        }
      }
    };

    for (const folder of this.folders) {
      if (folder.folderId === folderId) {
        return undefined;
      } else {
        const f = findFolder(folder);
        if (f) {
          return f;
        }
      }
    }
  }

  private async _searchMessages(folderId: number): Promise<Array<MSSMessage>> {
    return new Promise<Array<MSSMessage>>(async (resolve, reject) => {
      try {
        const messages = await this._mssSrv.getService().searchMessages(
          { email: this.userMail, idNat: this.selectedIdNat },
          {
            query: {
              folderId
            },
            limit: this.paginationConfig.itemsPerPage,
            offset: this.paginationConfig.currentPage * this.paginationConfig.itemsPerPage
          },
          true
        );

        resolve(messages);
      } catch (e) {
        reject(e);
      }
    });
  }

  private _openAlertModal(msg: string, title = 'Erreur'): void {
    this._modalSrv.openAlert(
      this._viewContainerRef,
      title,
      msg
    );
  }

  private _openHTMLError(htmlContent: string): void {
    const modal = this._modalSrv.openModal<HtmlErrorComponent>(
      this._viewContainerRef,
      HtmlErrorComponent
    ) as ComponentRef<HtmlErrorComponent>;
    modal.instance.htmlContent = htmlContent;
    const sub = modal.instance.closeEmitter.subscribe(() => {
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public goToMSSSettings(): void {
    this._router.navigateByUrl('/user/parametres/dmp');
  }

  private async _initProvider(): Promise<void> {
    if (!this.authenticationErrorSubscription) {
      this.authenticationErrorSubscription = this._mssSrv.getService().authenticationErrorSubject.subscribe(async (isLogged) => {
        if (!isLogged) {
          this.isConnected = false;
          if (this._mssSrv.getService().isTokenNeeded()) {
            this._mssSrv.getService().clearToken(this.selectedIdNat);
          }

          if (this._lastProviderSelected === MssTypeService.mailiz) {
            const modal = this._modalSrv.openModal<ConnectToMailizComponent>(
              this._viewContainerRef,
              ConnectToMailizComponent
            ) as ComponentRef<ConnectToMailizComponent>;

            modal.instance.idNat = this.selectedIdNat;
            const sub = modal.instance.closeEmitter.subscribe(async (res: string) => {
              modal.destroy();
              sub.unsubscribe();

              if (res === 'connected') {
                await this._saveMails(this.selectedIdNat, this._lastProviderSelected);
                await this._connexionOk();
              } else {
                this.userMail = undefined;
                this.selectedIdNat = undefined;
              }
            });
          } else if (this._lastProviderSelected === MssTypeService.apicrypt) {
            const modal = this._modalSrv.openModal<ConnectToApicryptComponent>(
              this._viewContainerRef,
              ConnectToApicryptComponent
            ) as ComponentRef<ConnectToApicryptComponent>;
            modal.instance.inputAccount = this._accountSelected.accountName;
            const sub = modal.instance.closeEmitter.subscribe(async (res: string) => {
              modal.destroy();
              sub.unsubscribe();

              if (res === 'connected') {
                await this._connexionOk();
              } else {
                this.userMail = undefined;
                this.selectedIdNat = undefined;
              }
            });
          }
        } else {
          this.isConnected = true;
        }
      });
    }

    await this.handleFolders();

    if (this.mustReleverCourrier) {
      this.releverCourrier();
    }
  }

  private async _initCpxSession(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, _) => {
      try {
        const isEs = await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_INSI);
        const session = await this._cpxHandleSrv.getCpxSession(this._viewContainerRef, isEs ? SessionTypeEnum.CERT_INSI : SessionTypeEnum.CARTE);
        if (!session) {
          resolve(false);
          return;
        } else {
          const currentProfilStr = localStorage.getItem('currentProfil');
          if (currentProfilStr && currentProfilStr !== '') {
            const currentProfil = JSON.parse(currentProfilStr);
            this._insSrv.resourceId = currentProfil.id;

            resolve(true);
            return;
          }

          resolve(false);
          return;
        }
      } catch {
        resolve(false);
      }
    });
  }

  releverCourrier(): void {
    let introtext;
    switch (this._lastProviderSelected) {
      case MssTypeService.mailiz:
        const selectSplit = (this.currentAccount.get('accountName').value as string).split('$');
        const account = selectSplit[0];
        const provider = selectSplit[1];
        const idNat = selectSplit[2];
        introtext = `Nous allons relever le courrier sur la boite selectionnée sur Mailiz : \n "${account} - ${idNat}".`;
        break;
      case MssTypeService.apicrypt:
        introtext = `Nous allons relever le courrier sur la boite selectionnée sur APICRYPT : \n "${this._accountSelected.accountName}".`;
        break;
      default:
        throw new Error('Type de service MSS inconnu');
    }

    let modal;
    if (this._lastProviderSelected === MssTypeService.apicrypt) {
      modal = this._modalSrv.openModal(
        this._viewContainerRef,
        RelevageApicryptComponent,
        [
          {name: 'header', value: 'Relève du courrier APICRYPT'},
          {name: 'msg', value: introtext + `\n\n` + 'Le service de relève du courrier, va récupérer les mails de votre boite principale pour les traiter.\nCeux-ci seront ensuite disponible dans l\'interface Courrier Relevés pour traitement ultérieur.'}
        ]
      );
    } else {
      modal = this._modalSrv.openModalConfirmation(
        this._viewContainerRef,
        'Relève du courrier',
        introtext + `\n\n` + 'Le service de relève du courrier, va récupérer les mails non lus dans votre boite principale pour les traiter.\nCeux-ci seront ensuite disponible dans l\'interface Courrier Relevés pour traitement ultérieur.'
      );
    }

    const sub = modal.instance.closeEmitter.subscribe(async (res) => {
      sub.unsubscribe();
      if (res) {
        if (this._lastProviderSelected === MssTypeService.apicrypt) {
          const apicryptService = this._mssSrv.getService() as MssApicryptService;
          if (apicryptService instanceof MssApicryptService) {
            apicryptService.doitReleverMessageLu = res.relevageLu || false;
            apicryptService.doitSupprimerApresRelevage = res.suppressionApresRelevage || false;
          }
        }else if(this._lastProviderSelected === MssTypeService.mailiz){
        const useCert = await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_INSI);
        if (useCert) {
          if (await this._initCpxSession()) {
            await this.doActionReleverCourrier();
          }
        } else if (!await this._cpxHandleSrv.isSessionOpen(useCert ? SessionTypeEnum.CERT_INSI : SessionTypeEnum.CARTE)) {
          const modalInfosConnexionCps = this._modalSrv.openAlert(
            this._viewContainerRef,
            'Connexion CPS nécessaire',
            'Une connexion CPS est nécessaire pour contrôler les patients liés aux courriers relevés'
          );
          const subInfosConnexionCps = modalInfosConnexionCps.instance.closeEmitter.subscribe(async _ => {
            subInfosConnexionCps.unsubscribe();
            // Connexion CPS
            const messageErreur = 'Une erreur est survenue lors de la connexion CPS\n\nIMPORTANT: Les patients des courriers ne seront pas contrôlés';
            let checkPatient = true;
            try {
              const result = await this._initCpxSession();
              if (!result) {
                const alert = this._modalSrv.openAlert(
                  this._viewContainerRef,
                  'Information',
                  messageErreur,
                );
                await new Promise<void>((resolve) => {
                  const sub = alert.instance.closeEmitter.subscribe(() => {
                    resolve();
                    sub.unsubscribe();
                    alert.destroy();
                  });
                });
                checkPatient = false;
              }
            } catch (e) {
              const alert = this._modalSrv.openAlert(
                this._viewContainerRef,
                'Information',
                messageErreur,
              );
              await new Promise<void>((resolve) => {
                const sub = alert.instance.closeEmitter.subscribe(() => {
                  resolve();
                  sub.unsubscribe();
                  alert.destroy();
                });
              });
              checkPatient = false;
            }

            // return;
            await this.doActionReleverCourrier(checkPatient);
          });
        } else {
          // return;
          await this.doActionReleverCourrier();
        }
        }
      }
      modal.destroy();
      if (res && this._lastProviderSelected === MssTypeService.apicrypt){ // apres modal destroy pour fermer fenetre copie serveur apicrypt
        let checkPatient = false;
        await this.doActionReleverCourrier(checkPatient);
      }
    });
  }

  private async _testPatientInsDuCourrierReleve(rtdCourrierReleve: MessageReleveTmp): Promise<boolean> {
    const _getSexeIndex = (sexe: string | undefined): 1 | 2 | 3 | undefined => {
      switch(sexe) {
        case 'INDETERMINE':
          return 1;
        case 'HOMME':
          return 2;
        case 'FEMME':
          return 3;
        default:
          return undefined;
      }
    };

    try {
      const testIns = await this._insSrv.checkInsIdentity(this._viewContainerRef, {
        i_sex: _getSexeIndex(rtdCourrierReleve.patientSexe),
        s_birthDate: moment(rtdCourrierReleve.patientDateNaissance, "YYYY-MM-DD").format("YYYYMMDD"),
        s_birthName: rtdCourrierReleve.patientNomNaissance.toUpperCase(),
        s_given: rtdCourrierReleve.patientPrenomNaissance.toUpperCase(),
        s_ins: rtdCourrierReleve.patientIns,
        s_key: rtdCourrierReleve.patientInsKey,
        s_oid: rtdCourrierReleve.patientOid,
        s_birthPlace: rtdCourrierReleve.patientCpNaissance
      });
      if (testIns === true) {
        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  }

  async doActionReleverCourrier(checkPatient=true): Promise<void> {
    let folderId;
    switch (this._lastProviderSelected) {
      case MssTypeService.mailiz:
        folderId = 2;
        break;
      case MssTypeService.apicrypt:
        folderId = 0;
        break;
      default:
        throw new Error('Type de service MSS inconnu');
    }

    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    let unreadMessages: MSSMessage[];
    try {
      unreadMessages = await this._mssSrv.getService().searchMessages(
        { email: this.userMail, idNat: this.selectedIdNat },
        {
          query: {
            folderId,
            includeSubfolders: true,
            seen: false
          },
        }
      );

      if (!this._mssSrv.getService().canGetMessage()) {
        /**
         * Si ApiCrypt n'a pas été en mesure de distribuer un message
         * la boite envoi automatiquement un mail indiquant que le message
         * n'a pas pu être délivré.
         * Il faut filtrer ces messages pour ne pas les traiter.
         * Ces message ont pour expediteur : postmaster@medical.apicrypt.org
         */
        unreadMessages = unreadMessages.filter(m => !m.addresses.find((a) => a.type === MSSEnumTypeMail.FROM && a.email === 'postmaster@medical.apicrypt.org'));
      }
    } catch (e) {
      if(e != 'Pas de messages'){ // si 'Pas de messages' alors e.message est undefined fausse erreur juste aucun message à relever
      this._openAlertModal(e.message);
      }
    } finally {
      loading.destroy();
    }

    // console.log('unreadMessages : ', unreadMessages);
    // unreadMessages = [
    //   unreadMessages.find(m => m.subject === 'XDM/1.0/DDM+Test TCHITCHI MICHELINE 1960-09-11'),
    //   unreadMessages.find(m => m.subject === 'XDM/1.0/DDM+Test MULLTIPRENOMS THOMAS 1975-11-11')
    // ];
    // XDM/1.0/DDM+Test TCHITCHI MICHELINE 1960-09-11
    // XDM/1.0/DDM+Test MULLTIPRENOMS THOMAS 1975-11-11
    // console.log('unreadMessages : ', unreadMessages);

    if (!unreadMessages || unreadMessages.length === 0) {
      this._openAlertModal('Aucun message à traiter n\'a été trouvé lors de la relève.');
      return;
    }

    // Si APICRYPT alors le query n'est pas pris en compte, on doit donc
    // filtrer les messages non lus
    // UPDATE les messages makAsRead sont ACK et ne devrait pas ressortir

    // if (this._lastProviderSelected === MssTypeService.apicrypt) {
      // const reallyUnreadMessages = unreadMessages.filter((m) => m.flags.find((f) => f === MSSEnumFlag.UNREAD));
      // unreadMessages = reallyUnreadMessages;
    // }


    const unreadMessagesIDs = unreadMessages.map((m) => m.messageId);
    console.log('unreadMessages', unreadMessages);
    console.log('unreadMessagesIDs', unreadMessagesIDs);

    let isHorsLimite = false;
    let isHorsLimiteCritique = false;

    const modal: ComponentRef<ProgressFragment> = this._modalSrv.openModal(
      this._viewContainerRef,
      ProgressFragment,
      [
        { name: 'header', value: 'Relève du courrier' },
        { name: 'msg', value: 'Veuillez patienter pendant le relève du courrier...' },
        { name: 'unit', value: 'courrier relevé(s)' },
        { name: 'total', value: unreadMessagesIDs.length },
        { name: 'errorModeMessage', value: 'Un ou plusieurs courriers n\'ont pas pu être relevés. La relève se poursuit avec les autres courriers.' },
        { name: 'otherInfosModeMessage', value: 'L\'INS d\'un patient trouvé dans un document IHE XDM est en cours de test' },
      ]
    );



    const errorRelevageMailiz: Map<MSSMessage, any> = new Map();
    const errorRelevageApiCrypt: Map<MSSMessage, any> = new Map();

    const _handleAndMarkAsRead = async (message: MSSMessage) => {
      // Recupération des pièces jointes
      try {
        if (message) {
          if (Array.isArray(message.attachments)) {
            for (const attachment of message.attachments) {
              if (!attachment.file || !attachment.size) {
                const {file, base64} = await this._mssSrv.getService().downloadAttachment(
                  { email: this.userMail, idNat: this.selectedIdNat },
                  message.messageId,
                  attachment
                  );
                attachment.file = base64;
                attachment.size = file.size;
              }
            }
          }
          const messageReleve = await this._mssSrv.getService().sauvegarderCourrierReleve(message);
          if (messageReleve) {
            // On test l'INS du patient du document
            let testIns = false;
            if (checkPatient && messageReleve && messageReleve.patientIns && messageReleve.patientInsKey && messageReleve.patientOid) {
              modal.instance.otherInfosMode = true;
              testIns = await this._testPatientInsDuCourrierReleve(messageReleve);
            }
            await this._mssSrv.getService().updateCourrierReleve({...messageReleve, isInsOk: testIns});
            // modal.instance.otherInfosMode = false;

            if (messageReleve.isCrBio && messageReleve.isHorsLimite) {
              isHorsLimite = true;
            }
            if (messageReleve.isCrBio && messageReleve.isHorsLimiteCritique) {
              isHorsLimiteCritique = true;
            }
          }

          await new Promise(resolve => setTimeout(resolve, 500));

          // At the end mark all messages as read
          await this._mssSrv.getService().markMessageAsRead({ email: this.userMail, idNat: this.selectedIdNat }, message.messageId, message.technicalId);
        } else {
          console.warn('Le message est vide (cas possible : message lu et option ne demandant pas la relève des messages lus)');
        }
      } catch (e) {
        errorRelevageMailiz.set(message, e);
        modal.instance.errorMode = true;
      } finally {
        modal.instance.increment();
      }
    };

    if (this._lastProviderSelected === MssTypeService.apicrypt && this._mssSrv.getService().canGetMessage()) {
      for (const messageId of unreadMessages) {
        try {
          const message = await this._mssSrv.getService().getMessageById({ email: this.userMail, idNat: this.selectedIdNat }, messageId.messageId.toString());
          await _handleAndMarkAsRead(message);
        } catch (e) {
          errorRelevageApiCrypt.set(messageId, e);
          modal.instance.errorMode = true;
          modal.instance.increment();
        }
      }
    } else {
      for (const unreadMessage of unreadMessages) {
        await _handleAndMarkAsRead(unreadMessage);
      }
    }
    modal.destroy();

    if (isHorsLimite || isHorsLimiteCritique) {
      const modalAlert = this._modalSrv.openAlert(
        this._viewContainerRef,
        'Alerte CR Bio',
        'Un ou plusieurs documents relevés sont des CR Bio comportants des valeurs anormales.\nVous pouvez-vous rendre sur la page des courriers relever pour les voir.',
        'Accéder aux courriers relevés'
      );
      const sub = modalAlert.instance.closeEmitter.subscribe(v => {
        sub.unsubscribe();
        modalAlert.destroy();
        if (v) {
          this._router.navigateByUrl('/user/messagerie/releves');
        }
      });
    }

    if (errorRelevageMailiz.size > 0) {
      let errors = '';
      for (const [message, error] of errorRelevageMailiz.entries()) {
        const from = message.addresses.find((address) => address.type ===  MSSEnumTypeMail.FROM);
        errors += `De ${from.name} <${from.email}, le ${message.date}\n`;
        errors += `Objet : ${message.subject}\n`;
        errors += `Erreur : ${error.message}\n\n`;
      }
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur(s) lors de la relève',
        'Un ou plusieurs courriers n\'ont pas pu être relevés. Veuillez réessayer ultérieurement.',
        undefined,
        errors
      );
      errorRelevageMailiz.clear();
    } else if (errorRelevageApiCrypt.size > 0) {
      let errors = '';
      for (const [message, error] of errorRelevageApiCrypt.entries()) {
        errors += `Message ID : ${message.messageId}\n`;
        errors += `Erreur : ${error.error.error || error.error || error.message}\n\n`;
      }
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur(s) lors de la relève',
        'Un ou plusieurs courriers n\'ont pas pu être relevés. Veuillez réessayer ultérieurement.',
        undefined,
        errors
      );
      errorRelevageApiCrypt.clear();
    } else {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Relève du courrier',
        'La relève du courrier a été effectuée avec succès.'
      );
    }
  }

  private async _addLog(obj: LogObject): Promise<void> {
    if (!this._logCallSrv) {
        this._logCallSrv = this._logSrv.getConfiguration(DomainEnum.Messagerie);
    }

    this._logCallSrv.addLog(obj);
}
}
